import { Button, Dropdown } from "antd";
import SiteLogo from "../../../../assets/images/site-logo.png";
import SVGIcon from "../../../../utils/SVGIcon";
import Logout from "../../../app_pages/Auth/Logout";
import { useState } from "react";
import { useSelector } from "react-redux";

const HeaderComponent = ({ collapsed, setCollapsed }) => {
  const { userProfileData } = useSelector((state) => state.auth);

  const [logoutModal, setLogoutModal] = useState(false);

  const openLogoutModal = () => {
    setLogoutModal(true);
  };

  const closeLogoutModal = () => {
    setLogoutModal(false);
  };

  // const notificationItems = [
  //   {
  //     label: <a href="https://www.antgroup.com">1st menu item</a>,
  //     key: "0",
  //   },
  //   {
  //     label: <a href="https://www.aliyun.com">2nd menu item</a>,
  //     key: "1",
  //   },
  // ];

  const profileItems = [
    {
      label: <div onClick={() => openLogoutModal()}>Logout</div>,
      key: "1",
    },
  ];

  return (
    <>
      <Logout open={logoutModal} close={closeLogoutModal} />
      <div className={`headerWrap ${!collapsed ? "sidebarExpanded" : ""}`}>
        <div className="leftHeader">
          <Button
            className="toggleMenu"
            type="primary"
            // onClick={handleMenuToggle}
            onClick={() => setCollapsed(!collapsed)}
          >
            <SVGIcon icon="toggle_menu" />
          </Button>
          <div className="siteLogo">
            <img src={SiteLogo} alt="Site Logo" />
          </div>
        </div>

        <div className="rightMenu">
          <ul>
            {/* <li>
              <AddModalComponent />
            </li> */}
            {/* <li>
              <Button
                className="iconBtn"
                // onClick={handleMenuToggle}
              >
                <SVGIcon icon="message" />
              </Button>
            </li>
            <li>
              <Dropdown
                menu={{
                  items: notificationItems,
                }}
                trigger={["click"]}
                placement="bottomRight"
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <Link to={(e) => e.preventDefault()}>
                  <SVGIcon icon="notification" />
                </Link>
              </Dropdown>
            </li> */}
            <li>
              <Dropdown
                menu={{
                  items: profileItems,
                }}
                trigger={["click"]}
                placement="bottom"
                arrow={{
                  pointAtCenter: true,
                }}
                overlayClassName="menuDropdown"
              >
                <div className="userProfileHead">
                  <span className="name">
                    Welcome, {userProfileData?.data?.name}!
                  </span>
                  {/*
                  <div className="userPhoto">
                    <img
                      src={AvatarImg}
                      // src={`data:image/jpeg;base64,${userProfileData?.photoUrl}`}
                      alt="User"
                    />
                  </div>
                     */}
                  <SVGIcon icon="dropdown_arrow" />
                </div>
                {/* <Link
                  to={(e) => e.preventDefault()}
                  className="userProfileHead"
                >
                  <div className="userPhoto">
                    <img src={AvatarImg} alt="User" />
                  </div>
                  <SVGIcon icon="dropdown_arrow" />
                </Link> */}
              </Dropdown>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default HeaderComponent;
